export default __webpack_public_path__ + "static/media/elza-oost.89c9f795.jpg";